module.exports = __webpack_public_path__ + "8bb98cfdfd89cd392a19cf3e9e015700.svg";